import { isPublicShellPath, normalizePathForPublicCheck } from '@src/modules/shared/bootstrap/infrastructure/applicationShellBootstrap.ts';
import { shellNavPathname } from '@src/modules/shared/app-context/domain/shellNavRoutes.ts';

export const POST_LOGIN_RETURN_URL_SESSION_KEY = 'bono_post_login_return_url';

/** Internal SPA target: pathname + search + hash (no origin). */
export function buildReturnUrlFromLocation(loc: Pick<Location, 'pathname' | 'search' | 'hash'> = globalThis.location): string {
  return `${loc.pathname}${loc.search}${loc.hash}`;
}

function isSafePostLoginReturnUrl(url: string): boolean {
  if (!url.startsWith('/')) return false;
  if (url.startsWith('//')) return false;
  const pathname = shellNavPathname(url);
  if (pathname === '/login') return false;
  if (isPublicShellPath(pathname)) return false;
  return true;
}

/** Persists the route to open after a successful in-app login. */
export function storePostLoginReturnUrl(url: string): void {
  const normalized = url.trim();
  if (!isSafePostLoginReturnUrl(normalized)) return;
  try {
    globalThis.sessionStorage.setItem(POST_LOGIN_RETURN_URL_SESSION_KEY, normalized);
  } catch {
    /* sessionStorage unavailable */
  }
}

/** Reads and clears the stored post-login route; falls back to `/`. */
export function consumePostLoginReturnUrl(fallback = '/'): string {
  let raw: string | null = null;
  try {
    raw = globalThis.sessionStorage.getItem(POST_LOGIN_RETURN_URL_SESSION_KEY);
    globalThis.sessionStorage.removeItem(POST_LOGIN_RETURN_URL_SESSION_KEY);
  } catch {
    return fallback;
  }
  if (!raw || !isSafePostLoginReturnUrl(raw)) return fallback;
  return raw;
}

/** Stores the current location when redirecting an unauthenticated user to login. */
export function storeCurrentLocationAsPostLoginReturnUrl(): void {
  const path = normalizePathForPublicCheck(globalThis.location.pathname);
  if (path === '/login' || isPublicShellPath(path)) return;
  storePostLoginReturnUrl(buildReturnUrlFromLocation());
}
